import { i18n } from "../translate/i18n";

export const formatInternalTicketProtocol = (internalTicket) => {
  if (!internalTicket?.id || !internalTicket?.createdAt) return "-";

  const date = new Date(internalTicket.createdAt);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);

  return `INT-${day}${month}${year}-${internalTicket.id}`;
};

export const getInternalTicketPriorityLabel = (priority) => {
  if (!priority) return "-";
  return i18n.t(`internalTickets.labels.priority.${priority}`) || priority;
};

export const getInternalTicketStatusLabel = (status) => {
  if (!status) return "-";
  return i18n.t(`internalTickets.labels.status.${status}`) || status;
};

export const getInternalTicketSlaLabel = (slaStatus) => {
  if (!slaStatus) return "-";
  return i18n.t(`internalTickets.labels.sla.${slaStatus}`) || slaStatus;
};
